


































































































































































































































































































































































import Vue, { PropType } from "vue";
import { Form } from "element-ui";
import { axios } from "../../plugins";

import {
  CreateAppForm,
  Mount,
  Volumn,
  CreateAppData,
  kind,
  KindOptions,
  Iaffinity,
  Itolerations,
  strategyOptions,
  strategyOptions2
} from "./transform";
import { ModelEnum } from "@/components/MySelectStorage.vue";
import AffinityEdit from "./AffinityEdit.vue";
import StaintEdit from "./StaintEdit.vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "Cteate",
  components: { AffinityEdit, StaintEdit },
  props: {
    projectId: { type: String },
    appCode: { type: String },
    type: { type: String as PropType<kind> }
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      affinityShow: false,
      unaffinityShow: false,
      value: "",
      rules: {
        "metadata.labels.appmgr-app": [
          { required: true, type: "string", pattern: /^(?!-)[a-z0-9-]*[^-]$/ }
        ],
        "ruleForm.spec.template.spec.containers": [
          { required: true, type: "array", min: 1 }
        ],
        "spec.template.spec.volumeClaimTemplates": [
          { required: true, type: "array", min: 1 }
        ]
        // "spec.serviceName": [{ required: true }]
      },

      ruleForm: JSON.parse(
        JSON.stringify(CreateAppForm)
      ) as typeof CreateAppForm,
      ModelEnum,
      KindOptions,
      strategyOptions,
      strategyOptions2,
      editIndex: undefined as any,
      keyOptions: [],
      configOptions: [],
      storageOptions: [],
      serviceOptions: []
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "project"]),
    ...mapGetters("LoginInfo", ["tenant"])
  },
  deactivated() {
    this.quit();
  },
  mounted() {
    this.getKey();
    this.getConfig();
    this.getStorage();
  },
  methods: {
    strategychange(value: string) {
      if (value === "Recreate") {
        delete this.ruleForm.spec.strategy?.rollingUpdate;
      }
      if (value === "OnDelete") {
        delete this.ruleForm.spec.updateStrategy?.rollingUpdate;
      }
    },
    // 获取密钥
    getKey() {
      return axios.get(`/secret/list?projectId=${this.projectId}`).then(res => {
        this.keyOptions = res.data.data;
      });
    },
    // 获取配置
    getConfig() {
      return axios.get(`/configmap/${this.projectId}`).then(res => {
        this.configOptions = res.data.data.items;
      });
    },
    // 获取存储列表
    getStorage() {
      return axios.get(`/storage/${this.projectId}`).then(res => {
        this.storageOptions = res.data.data;
      });
    },
    findStorage(name: string) {
      return (this.storageOptions as any[]).find(item => item.name === name);
    },
    findVolumn(name: string) {
      const data: Volumn[] = [];
      (this.ruleForm as CreateAppData).spec.template.spec.containers.forEach(
        contaner => {
          if (!contaner.volumeMounts) return;
          contaner.volumeMounts.forEach(volumn => {
            if (volumn.name === name) {
              data.push({
                name: contaner.name,
                mountPath: volumn.mountPath,
                subPath: volumn.subPath
              });
            }
          });
        }
      );

      return data;
    },
    show(data?: any) {
      if (data) {
        this.isEdit = true;
        this.ruleForm = JSON.parse(JSON.stringify(data));
        if (!this.ruleForm.metadata.annotations) {
          this.ruleForm.metadata.annotations = JSON.parse(
            JSON.stringify(CreateAppForm.metadata.annotations)
          );
        }
        this.dialog = true;
      } else {
        // 创建状态
        this.isEdit = false;

        if (this.ruleForm.metadata.annotations) {
          this.ruleForm.metadata.annotations[
            "appmgr.object.createBy"
          ] = this.userinfo.username;
        }
        this.ruleForm.kind = this.type;
        if (this.ruleForm.kind === "Deployment") {
          delete this.ruleForm.spec.updateStrategy;
        } else if (this.ruleForm.kind === "StatefulSet") {
          delete this.ruleForm.spec.strategy;
        }

        this.dialog = true;
      }
    },
    // 名称变化 响应
    nameChange(val: string) {
      this.ruleForm.metadata.labels.app = val;
      this.ruleForm.spec.selector.matchLabels.app = val;
      this.ruleForm.spec.template.metadata.labels.app = val;
    },
    showSelectImage(data?: any) {
      if (data?.index > -1) {
        // 判断编辑状态 设置编辑的数组子下标
        (this.$refs.selectImage as any).show(
          data?.data,
          // 编辑 image时 将 imagePullSecrets 传回编辑页面
          this.ruleForm.spec.template.spec.imagePullSecrets?.[data?.index]
        );

        this.editIndex = data?.index;
      } else {
        (this.$refs.selectImage as any).show();
      }
    },
    addImage({ data, info, secret }: any) {
      const newData = JSON.parse(data);
      newData.info = JSON.parse(info);
      if (this.editIndex !== undefined) {
        this.ruleForm.spec.template.spec.containers.splice(
          this.editIndex,
          1,
          newData
        );

        this.ruleForm.spec.template.spec.imagePullSecrets.splice(
          this.editIndex,
          1,
          secret
        );
        this.editIndex = undefined;
      } else {
        if (!this.ruleForm.spec.template.spec.containers) {
          this.ruleForm.spec.template.spec.containers = [];
        }
        this.ruleForm.spec.template.spec.containers.push(newData);
        if (!this.ruleForm.spec.template.spec.imagePullSecrets) {
          this.ruleForm.spec.template.spec.imagePullSecrets = [];
        }
        this.ruleForm.spec.template.spec.imagePullSecrets.push(secret);
      }
    },
    delImage(index: number) {
      this.ruleForm.spec.template.spec.containers.splice(index, 1);
      this.ruleForm.spec.template.spec.imagePullSecrets.splice(index, 1);
    },
    //
    showStaintEdit() {
      (this.$refs.staint as any).show(
        this.ruleForm?.spec?.template?.spec?.tolerations
      );
    },
    showVolumn(data: any) {
      if (typeof data === "number") {
        if (data === 0) {
          (this.$refs.storage as any).show();
        } else {
          (this.$refs.config as any).show();
        }
      } else {
        // 编辑
        if (
          data.data["persistentVolumeClaim"] ||
          data.data["emptyDir"] ||
          data.data["hostPath"]
        ) {
          // 存储卷
          (this.$refs.storage as any).show(data.data);
        } else {
          (this.$refs.config as any).show(data.data);
        }
        this.editIndex = data.index;
      }
    },
    addVolumn({ data, images }: any) {
      const newData = JSON.parse(data);
      const newImages: Mount[] = JSON.parse(images);

      if (this.editIndex !== undefined) {
        this.ruleForm.spec.template.spec.volumes.splice(
          this.editIndex,
          1,
          newData
        );
        this.editIndex = undefined;
      } else {
        if (!this.ruleForm.spec.template.spec.volumes) {
          this.ruleForm.spec.template.spec.volumes = [];
        }

        this.ruleForm.spec.template.spec.volumes.push(newData);
      }

      if (newImages.length) {
        // 挂载
        this.bindImage(newImages, newData.name);
      } else {
        // 解除绑定
        this.unbindImage(newData.name);
      }
    },
    delVolumn(index: number) {
      const data = this.ruleForm.spec.template.spec.volumes.splice(index, 1);
      // 解除镜像绑定
      this.unbindImage(data[0].name);
    },
    // 负载类型切换
    kindChange(value: kind) {
      if (value === "StatefulSet") {
        delete this.ruleForm.spec.strategy;
        this.$set(this.ruleForm.spec, "volumeClaimTemplates", []);
        this.$set(this.ruleForm.spec, "updateStrategy", {
          type: "OnDelete"
        });
      } else {
        delete this.ruleForm.spec.volumeClaimTemplates;
        delete this.ruleForm.spec.updateStrategy;
        this.$set(this.ruleForm.spec, "strategy", {
          type: "Recreate"
        });
      }
    },
    showSeleckTemplete(data?: any) {
      (this.$refs.templete as any).show(data?.data);
      this.editIndex = data?.index;
    },
    addTemplete({ data, images }: any) {
      const newData = JSON.parse(data);
      const newImages: Mount[] = JSON.parse(images);

      if (this.editIndex !== undefined) {
        this.ruleForm.spec.volumeClaimTemplates?.splice(
          this.editIndex,
          1,
          newData
        );
        this.editIndex = undefined;
      } else {
        if (!this.ruleForm.spec.volumeClaimTemplates) {
          this.ruleForm.spec.volumeClaimTemplates = [];
        }
        this.ruleForm.spec.volumeClaimTemplates?.push(newData);
      }

      if (newImages.length) {
        // 挂载
        this.bindImage(newImages, newData.metadata.name);
      } else {
        // 解除绑定
        this.unbindImage(newData.metadata.name);
      }
    },
    delTemplete(index: number) {
      const data = (this.ruleForm.spec.volumeClaimTemplates as any).splice(
        index,
        1
      );
      // 解除镜像绑定
      this.unbindImage(data[0].metadata.name);
    },
    // 容器绑定
    bindImage(newImages: Mount[], name: string) {
      // 挂载
      (this.ruleForm as CreateAppData).spec.template.spec.containers.forEach(
        item => {
          const bindImage = newImages.find(m => m.name === item.name);
          // 存储卷绑定该镜像
          if (bindImage) {
            if (!item.volumeMounts) {
              // 镜像未绑定过此存储卷
              item.volumeMounts = [];
              item.volumeMounts.push({
                name: name,
                readOnly: bindImage.readOnly,
                mountPath: bindImage.mountPath,
                subPath: bindImage.subPath
              });
            }
            const index = item.volumeMounts.findIndex(v => v.name === name);
            // 镜像绑定过存储卷
            if (index > -1) {
              item.volumeMounts[index].readOnly = bindImage.readOnly;
              item.volumeMounts[index].mountPath = bindImage.mountPath;
              item.volumeMounts[index].subPath = bindImage.subPath;
            } else {
              // 镜像未绑定过此存储卷
              item.volumeMounts.push({
                name: name,
                readOnly: bindImage.readOnly,
                mountPath: bindImage.mountPath,
                subPath: bindImage.subPath
              });
            }
          }
        }
      );
    },
    // 容器解除绑定
    unbindImage(name: string) {
      // 解除镜像绑定
      (this.ruleForm as CreateAppData).spec.template.spec.containers.forEach(
        container => {
          if (!container.volumeMounts) return;
          const index = container.volumeMounts.findIndex(
            volumn => volumn.name === name
          );
          if (index > -1) {
            container.volumeMounts.splice(index, 1);
          }
        }
      );
    },
    showAttiEdit() {
      (this.$refs.affi as any).show(
        this.ruleForm?.spec?.template?.spec?.affinity
      );
    },
    setAtti(data: Iaffinity) {
      this.ruleForm.spec.template.spec.affinity = data;
    },
    setTaint(data: Itolerations[]) {
      this.ruleForm.spec.template.spec.tolerations = data;
    },
    quit() {
      this.ruleForm = JSON.parse(JSON.stringify(CreateAppForm));
      this.$refs.ruleForm && (this.$refs.ruleForm as Form).clearValidate();
      this.dialog = false;
      this.$emit("afterClose");
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    create() {
      const data: CreateAppData = JSON.parse(JSON.stringify(this.ruleForm));
      data.spec.template.spec.containers.forEach(constainer => {
        delete (constainer as any).info;
      });
      data.metadata.namespace = `${this.tenant.code}-${this.project.projectName}`;

      if (
        data.spec.template.spec.affinity.nodeAffinity
          .requiredDuringSchedulingIgnoredDuringExecution?.nodeSelectorTerms[0]
          .matchExpressions.length === 0
      ) {
        delete data.spec.template.spec.affinity.nodeAffinity
          .requiredDuringSchedulingIgnoredDuringExecution;
      }
      if (
        // @ts-ignore
        data.spec.template.spec.affinity.nodeAffinity
          .preferredDuringSchedulingIgnoredDuringExecution.length === 0
      ) {
        delete data.spec.template.spec.affinity.nodeAffinity
          .preferredDuringSchedulingIgnoredDuringExecution;
      }

      if (
        !data.spec.template.spec.affinity.nodeAffinity
          .requiredDuringSchedulingIgnoredDuringExecution &&
        // @ts-ignore
        !data.spec.template.spec.affinity.nodeAffinity
          .preferredDuringSchedulingIgnoredDuringExecution
      ) {
        delete data.spec.template.spec.affinity;
      }
      // taints
      if (data.spec.template.spec.tolerations?.length === 0) {
        delete data.spec.template.spec.tolerations;
      }
      let url = "";
      if (data.kind === "Deployment") {
        url = "/deployment/";
        delete data.spec.serviceName;
      } else if (data.kind === "StatefulSet") {
        url = "/statefulset/";
      }
      axios
        .post(`${url}${this.projectId}`, data)
        .then(() => {
          this.$message.success("组件创建成功");
          this.quit();
          this.$emit("afterEdit", data.kind);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit() {
      const data: CreateAppData = JSON.parse(JSON.stringify(this.ruleForm));
      data.spec.template.spec.containers.forEach(constainer => {
        delete (constainer as any).info;
      });

      if (
        data.spec.template.spec.affinity?.nodeAffinity
          .requiredDuringSchedulingIgnoredDuringExecution?.nodeSelectorTerms[0]
          .matchExpressions.length === 0
      ) {
        delete data.spec.template.spec.affinity.nodeAffinity
          .requiredDuringSchedulingIgnoredDuringExecution;
      }
      if (
        // @ts-ignore
        data.spec.template.spec.affinity?.nodeAffinity
          ?.preferredDuringSchedulingIgnoredDuringExecution?.length === 0
      ) {
        delete data.spec.template.spec.affinity.nodeAffinity
          .preferredDuringSchedulingIgnoredDuringExecution;
      }

      if (
        !data.spec.template.spec.affinity?.nodeAffinity
          ?.requiredDuringSchedulingIgnoredDuringExecution &&
        // @ts-ignore
        !data.spec.template.spec.affinity?.nodeAffinity
          ?.preferredDuringSchedulingIgnoredDuringExecution
      ) {
        delete data.spec.template.spec.affinity;
      }
      // taints
      if (data.spec.template.spec.tolerations?.length === 0) {
        delete data.spec.template.spec.tolerations;
      }
      let url = "";
      if (data.kind === "Deployment") {
        url = "/deployment/";
        delete data.spec.serviceName;
      } else if (data.kind === "StatefulSet") {
        url = "/statefulset/";
      }
      axios
        .put(`${url}${this.projectId}`, data)
        .then(() => {
          this.$message.success("组件修改成功");
          this.quit();
          this.$emit("afterEdit", data.kind);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
